import { ThemeProvider } from '@mui/material';
import { UnpyEvent } from 'domain/event/UnpyEvent';
import { PageLayout } from 'primary/Components/PageLayout/PageLayout';
import { Title } from 'primary/Components/Title/Title';
import { EVENT_CONTEXT } from 'primary/context/event/EventContext';
import { EventUnpyAdminForm } from 'primary/events/forms/EventUnpyAdminForm';
import { useContextDependency } from 'primary/hooks/useContextDependency';
import { useTranslate } from 'primary/hooks/useTranslate';
import React, { useContext } from 'react';

import { themeParameters } from '../parameters.helper';

export const UnpyAdminParameters = () => {
  const { event, dispatch } = useContext(EVENT_CONTEXT);
  const { eventRepository } = useContextDependency();
  const t = useTranslate();
  if (!event) return null;

  const onSubmitted = () => {
    eventRepository
      .getEventById(event.id)
      .then((value: UnpyEvent) => dispatch({ type: 'SET_EVENT', event: value }));
  };

  return (
    <div className={'eventAppearence'}>
      <PageLayout>
        <>
          <Title
            title={t('event.parameters.unpyAdmin.title')}
            level={1}
            compensatePadding
            threeQuarter
            bordered
          />
          <ThemeProvider theme={themeParameters}>
            <EventUnpyAdminForm event={event} onCreated={onSubmitted} />
          </ThemeProvider>
        </>
      </PageLayout>
    </div>
  );
};
